import { Box, Typography } from '@mui/material'

interface CheapestQuickestCardLabelProps {
    children: React.ReactNode
    label: string
    isActive: boolean
    sortOptionId: string
    isMobile: boolean
    isCombined?: boolean
}

const CHEAPEST_COLOR = '#22c55e'
const QUICKEST_COLOR = '#F66826'

const colorMap = {
    cheapest: CHEAPEST_COLOR,
    quickest: QUICKEST_COLOR
}

const CheapestQuickestCardLabel: React.FC<CheapestQuickestCardLabelProps> = ({
    children,
    isActive,
    label,
    sortOptionId,
    isMobile,
    isCombined
}) => {
    const isCheapest = sortOptionId === 'cheapest'
    const ids = isCombined ? sortOptionId.split('_') : [sortOptionId]
    const labels = isCombined ? label.split('_') : [label]
    return (
        <Box mb={1}>
            <Box display={'flex'} justifyContent={'flex-start'}>
                {ids?.map((id, index) => {
                    return (
                        <Box
                            key={id}
                            bgcolor={colorMap[id as keyof typeof colorMap]}
                            width={'100px'}
                            ml={3}
                            sx={{
                                borderTopLeftRadius: 8,
                                borderTopRightRadius: 8
                            }}
                        >
                            <Typography variant="body2" color={'white'} textAlign={'center'} fontWeight={600}>
                                {labels[index]}
                            </Typography>
                        </Box>
                    )
                })}
            </Box>

            <Box
                borderRadius={isMobile ? 2 : 1}
                border={
                    isCombined
                        ? 'none' // We'll use custom borders for combined
                        : `1px solid ${isCheapest ? CHEAPEST_COLOR : QUICKEST_COLOR}`
                }
                boxShadow={
                    isActive && !isCombined ? `0 0 10px 0 ${isCheapest ? CHEAPEST_COLOR : QUICKEST_COLOR}` : 'none'
                }
                sx={{
                    transition: 'all 0.3s ease',
                    ...(isCombined && {
                        background: `linear-gradient(to right, ${CHEAPEST_COLOR}, ${QUICKEST_COLOR})`,
                        p: 0.2
                    })
                }}
            >
                {children}
            </Box>
        </Box>
    )
}

export default CheapestQuickestCardLabel
